import { render, staticRenderFns } from "./CurriculumCategory.vue?vue&type=template&id=4e4ccdc3"
import script from "./CurriculumCategory.vue?vue&type=script&lang=js"
export * from "./CurriculumCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4ccdc3')) {
      api.createRecord('4e4ccdc3', component.options)
    } else {
      api.reload('4e4ccdc3', component.options)
    }
    module.hot.accept("./CurriculumCategory.vue?vue&type=template&id=4e4ccdc3", function () {
      api.rerender('4e4ccdc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/CurriculumCategory.vue"
export default component.exports